<template>

  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt"  getUrl="/web/basic/material/removal/rule/page"
                   getKey="rows" :columns="columns">
      <!-- 左侧按钮插槽 -->
      <template #buttonsL="scope">
        <el-button type="primary" size="mini" @click="yt.showEditDialog('xinzeng',null,'w1');setAddDefaultValue()">
          {{$t('xinzeng')}}
        </el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" :loading="yt.editObj.loading" class="font-color-danger"
                       @click="yt.remove(scope.row,'/web/basic/material/removal/rule/delete')">{{$t('shanchu')}}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
               :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item  :label="$t('xiajiaguize')" required>
            <yi_dictionary_select :type="'MATERIAL_REMOVAL_RULE'" :ids.sync="yt.editObj.removalRule"  @change="handleChange">
            </yi_dictionary_select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST','/web/basic/material/removal/rule/create',beforeAdd)"
                     type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
      </template>
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item  :label="$t('xiajiaguize')" required>
            <yi_dictionary_select :type="'MATERIAL_REMOVAL_RULE'" :ids.sync="yt.editObj.removalRule">
            </yi_dictionary_select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST','/web/basic/material/removal/rule/update')" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
      </template>
    </el-dialog>
  </div>

</template>

<script type="text/javascript">
export default {
  name: 'web_base_matter_off_shelf_rule',
  data() {
    return {
      materialList:[],
      materialBatchIdDisabled:true,
      columns: [{
        label: 'xiajiaguize',
        prop: 'removalRule',
        type: 'dictionary',
        key: 'MATERIAL_REMOVAL_RULE',
      }, {
        label: 'chuangjianren',
        prop: 'createByObject.nickname',
      }, {
        label: 'chuangjianshijian',
        prop: 'createTime',
        type: 'time',
      }, {
        label: 'caozuo',
        type: 'slot',
        fixed: 'right',
        width: 120
      }]
    }
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        materialId: this.$attrs.material.id,
        pageNum: 1,
        pageSize: 100
      }
      this.yt.get(1);
      this.yt.isShowPagination = false;
    }, 300)

  },
  methods: {
    beforeAdd(params, url) {
      params.materialId = this.$attrs.material.id
      return params
    },
    setAddDefaultValue() {
      this.yt.editObj.removalRule = "1";
    },
    async getMaterialList() {
      return await this.http.get('/web/basic/material/batch/page?' + this.qs.stringify({
        pageNum: 1,
        pageSize: 999,
        isEnabled: 1,
      })).then(response => {
        this.materialList = response.data.rows || []
      })
    },
    handleChange(value) {
      if(this.yt.editObj.manageMode==='2') {
        this.materialBatchIdDisabled = false
      }else {
        this.materialBatchIdDisabled = true
      }

      console.log('manageModeChange',this.yt.editObj.manageMode)
    }
  }
}
</script>

<style scoped lang="scss">

</style>
